import React from 'react';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { 
  User, 
  Settings, 
  HelpCircle, 
  LogOut,
  Shield,
  Bell,
  Key,
  Boxes,
  UserCog
} from 'lucide-react';
import { Link } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';

export const UserMenu = () => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  console.log(user);
  const handleSignOut = () => {
    navigate('/signout');
  };

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <button className="flex items-center space-x-2 p-1.5 rounded-lg hover:bg-[#1A1F2E] transition-colors group">
          <div className="h-8 w-8 rounded-full bg-blue-500/10 flex items-center justify-center">
            {user?.avatarUrl ? (
              <img
                src={`${user.avatarUrl || `https://avatar.vercel.sh/${user.email?.split("@")[0]}.svg?text=${user.getDisplayName?.toUpperCase()?.slice(0, 3) || user.email?.split("@")[0]}`}`}
                alt={user.getDisplayName}
                className="h-8 w-8 rounded-full"
              />
            ) : (
              <User className="h-5 w-5 text-blue-500" />
            )}
          </div>
          <div className="hidden md:block text-left">
            <div className="text-sm font-medium text-white">
              {user?.getDisplayName}
            </div>
            <div className="text-xs text-gray-500">
              {user?.email}
            </div>
          </div>
        </button>
      </DropdownMenu.Trigger>

      <DropdownMenu.Portal>
        <DropdownMenu.Content
          className="w-64 bg-[#1A1F2E] rounded-lg border border-gray-800 shadow-xl animate-in fade-in-0 zoom-in-95"
          sideOffset={5}
          align="end"
        >
          <div className="px-3 py-2 border-b border-gray-800">
            <div className="font-medium text-sm text-white">{user?.getDisplayName}</div>
            <div className="text-xs text-gray-500">{user?.email}</div>
          </div>

          <div className="px-1.5 py-2">
            <DropdownMenu.Item asChild>
              <Link to="/settings/general" className="flex items-center px-2 py-2 rounded-md text-sm text-gray-300 hover:bg-gray-800/50 cursor-pointer outline-none">
                <Settings className="h-4 w-4 text-gray-400 mr-2" />
                General Settings
              </Link>
            </DropdownMenu.Item>
            <DropdownMenu.Item asChild>
              <Link to="/settings/security" className="flex items-center px-2 py-2 rounded-md text-sm text-gray-300 hover:bg-gray-800/50 cursor-pointer outline-none">
                <Shield className="h-4 w-4 text-gray-400 mr-2" />
                Security Settings
              </Link>
            </DropdownMenu.Item>
            <DropdownMenu.Item asChild>
              <Link to="/settings/notifications" className="flex items-center px-2 py-2 rounded-md text-sm text-gray-300 hover:bg-gray-800/50 cursor-pointer outline-none">
                <Bell className="h-4 w-4 text-gray-400 mr-2" />
                Notification Settings
              </Link>
            </DropdownMenu.Item>
          </div>

          <DropdownMenu.Separator className="h-px bg-gray-800 mx-1.5 my-1" />

          <div className="px-1.5 py-2">
            {/* <DropdownMenu.Item asChild>
              <Link to="/settings/api" className="flex items-center px-2 py-2 rounded-md text-sm text-gray-300 hover:bg-gray-800/50 cursor-pointer outline-none">
                <Key className="h-4 w-4 text-gray-400 mr-2" />
                API Keys
              </Link>
            </DropdownMenu.Item> */}
            <DropdownMenu.Item asChild>
              <Link to="/settings/integrations" className="flex items-center px-2 py-2 rounded-md text-sm text-gray-300 hover:bg-gray-800/50 cursor-pointer outline-none">
                <Boxes className="h-4 w-4 text-gray-400 mr-2" />
                Integrations
              </Link>
            </DropdownMenu.Item>
            <DropdownMenu.Item asChild>
              <Link to="/settings/team" className="flex items-center px-2 py-2 rounded-md text-sm text-gray-300 hover:bg-gray-800/50 cursor-pointer outline-none">
                <UserCog className="h-4 w-4 text-gray-400 mr-2" />
                Team Management
              </Link>
            </DropdownMenu.Item>
          </div>

          <DropdownMenu.Separator className="h-px bg-gray-800 mx-1.5 my-1" />

          <div className="px-1.5 py-2">
            <DropdownMenu.Item className="flex items-center px-2 py-2 rounded-md text-sm text-gray-300 hover:bg-gray-800/50 cursor-pointer outline-none">
              <HelpCircle className="h-4 w-4 text-gray-400 mr-2" />
              Help & Support
            </DropdownMenu.Item>
            <DropdownMenu.Item 
              className="flex items-center px-2 py-2 rounded-md text-sm text-red-400 hover:bg-gray-800/50 cursor-pointer outline-none"
              onSelect={handleSignOut}
            >
              <LogOut className="h-4 w-4 mr-2" />
              Sign Out
            </DropdownMenu.Item>
          </div>
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
};